// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"a0180b57","584":"0b720daf"}[chunkId] + ".chunk.js";
};